import { render, staticRenderFns } from "./ProcessCrud.vue?vue&type=template&id=7ba1e68e"
import script from "./ProcessCrud.vue?vue&type=script&lang=js"
export * from "./ProcessCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports